// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1A7-t","label":"styles_label__2NWud"};